<template>
  <div id="productPage">


  <Header msg="/product" />
  <div class='bannerBox' :style="{backgroundImage:'url('+require('@/assets/porduct/product.jpg')+')'}"></div>
   
  <div class='productNav' :class='boxShow?"topNav":""'>
      <div  class='productNavBox'>
          <div class='productNavLeft'>
          <div :class='activeNav==0?"navAc":""' data-nav='0' @click='handleNav' >所有产品</div>
          <div :class='activeNav==1?"navAc":""' data-nav='1' @click='handleNav'>维生素</div>
          <div :class='activeNav==2?"navAc":""' data-nav='2' @click='handleNav'>矿物质</div>
          <div :class='activeNav==3?"navAc":""' data-nav='3' @click='handleNav'>草本植物</div>
          <div :class='activeNav==4?"navAc":""' data-nav='4' @click='handleNav'>益生菌</div>
          <div :class='activeNav==5?"navAc":""' data-nav='5' @click='handleNav'>专业</div>
      </div>
      <div class='productNavRight' @click='showAllNav' style='cursor:pointer;'>
          <div>筛选</div>
          <img :src="cateAction">
      </div>

          <div class='allNav'  v-if='showAllcate'>
       
                <div class='allNavBox'>
                  <img :src="require('@/assets/del-group.png')" class="colse" @click='showAllNav'>
                  <div class='allNavItem' data-navid='0' @click='handleAllNav'>
                      <img :src="allcateimg" >
                      <div>全部</div>
                    </div>

                    <div class='allNavItem' v-for='item in cateList' >
                      <img :src="item.img" :data-navid='item.id' @click='handleAllNav' style='cursor:pointer;'>
                      <div :data-navid='item.id' @click='handleAllNav' style='cursor:pointer;'>{{item.title}}</div>
                    </div>
                </div>
                
            </div>

          </div>
      
  </div>

  <div class='goods'>
      <div class='goodsBox vitamins' v-if='goodsLabel1.length>0'>
          <div class='goodsTitle'>
            <div class='goodsName'>维生素</div>
            <div class='goodsEn'>Vitamins</div>
          </div>
          <div class='goodsSubject'>
              <PorductBox :goods="item" v-for='item in goodsLabel1' class='goodsSubjectitme'/>
          </div>
      </div>

       <div class='goodsBox minerals' v-if='goodsLabel2.length>0'>
          <div class='goodsTitle'>
            <div class='goodsName'>矿物质</div>
            <div class='goodsEn'>Minerals</div>
          </div>
          <div class='goodsSubject'>
              <PorductBox :goods="item" v-for='item in goodsLabel2' class='goodsSubjectitme'/>
          </div>
      </div>

      <div class='goodsBox herbs' v-if='goodsLabel3.length>0'>
          <div class='goodsTitle'>
            <div class='goodsName'>草本植物</div>
            <div class='goodsEn'>Herbs</div>
          </div>
          <div class='goodsSubject'>
              <PorductBox :goods="item" v-for='item in goodsLabel3' class='goodsSubjectitme'/>
          </div>
      </div>

      <div class='goodsBox probiotic' v-if='goodsLabel4.length>0'>
          <div class='goodsTitle'>
            <div class='goodsName'>益生菌</div>
            <div class='goodsEn'>Probiotic</div>
          </div>
          <div class='goodsSubject'>
              <PorductBox :goods="item" v-for='item in goodsLabel4' class='goodsSubjectitme'/>
          </div>
      </div>

      <div class='goodsBox profession' v-if='goodsLabel5.length>0'>
          <div class='goodsTitle'>
            <div class='goodsName'>专业</div>
            <div class='goodsEn'>Profession</div>
          </div>
          <div class='goodsSubject'>
              <PorductBox :goods="item" v-for='item in goodsLabel5' class='goodsSubjectitme'/>
          </div>
      </div>


  </div>
  
  
  <Foot />
    


  </div>
</template>

<script>
// @ is an alias to /src

import Header from '@/components/header.vue'
import Foot from '@/components/foot.vue'
import PorductBox from '@/components/productBox.vue'

export default {
  name: 'product',
  components: {
      Header,
      Foot,
      PorductBox
  },
  data:()=>{
    return{
        height:680,
        boxShow:false,
        showAllcate:false,
        activeNav:0,
        activeId:0,
        cateList:[],
        cateAction:require('@/assets/bg/alltype.png'),
        allcateimg:require('@/assets/bg/alltype.png'),
        productList:[],
        goodsLabel1:[],
        goodsLabel2:[],
        goodsLabel3:[],
        goodsLabel4:[],
        goodsLabel5:[],
    }
  },

  beforeCreate:function(){
  	let that = this
    this.axios({
            method: 'post',
            url: 'goods/catGoods',
            data: {
				cid: this.activeId
			}
          }).then(res=>{
            console.log(res.data)
            that.productList = res.data.goodsList
            that.computeGoodsType()
          })
     this.axios({
            method: 'post',
            url: 'category/index',
          }).then(res=>{
            console.log(res.data)
            that.cateList = res.data.categorys
          })
  },
  methods:{
    // 商品分类
    computeGoodsType:function(){
      let _goodsList = this.productList
      let _goodsLabel1 = [],  //维生素
          _goodsLabel2 = [],  //矿物质
          _goodsLabel3 = [],  //草本
          _goodsLabel4 = [],  //益生菌
          _goodsLabel5 = [];  //特色产品

      _goodsList.forEach((item)=>{
        if (item.label == 1){
          _goodsLabel1.push(item)
        } else if (item.label == 2){
          _goodsLabel2.push(item)
        } else if (item.label == 3) {
          _goodsLabel3.push(item)
        } else if (item.label == 4) {
          _goodsLabel4.push(item)
        } else if (item.label == 5) {
          _goodsLabel5.push(item)
        }
      })
      this.goodsLabel1 = _goodsLabel1
      this.goodsLabel2 = _goodsLabel2
      this.goodsLabel3 = _goodsLabel3
      this.goodsLabel4 = _goodsLabel4
      this.goodsLabel5 = _goodsLabel5
    },
    showAllNav(){
      this.showAllcate = !this.showAllcate
      // this.$store.commit("saveCartNum",this.$store.state.cartNum + 1)
    
    },
    //所有分类
    handleAllNav(e){
      
      let _cateList = this.cateList
      let _navid = 0
      let _cateAction = require('@/assets/bg/alltype.png')
      _cateList.forEach((item)=>{
          if(item.id == e.target.dataset.navid){
            _cateAction = item.img
            _navid = item.id
          }
      })

      let that = this
      this.axios({
              method: 'post',
              url: 'goods/catGoods',
              data: {
                cid:_navid
              }
            }).then(res=>{
              console.log(res.data)
              that.productList = res.data.goodsList
              that.computeGoodsType()
              that.cateAction = _cateAction
              that.showAllcate = false
            })


    },
    // 点击导航
    handleNav(e){

      this.activeNav = e.target.dataset.nav||0
      let _scrollbox =48
      if(this.activeNav==1){
        _scrollbox =$(".vitamins").offset().top
      }else if(this.activeNav==2){
        _scrollbox =$(".minerals").offset().top
      }else if(this.activeNav==3){
        _scrollbox =$(".herbs").offset().top
      }else if(this.activeNav==4){
        _scrollbox =$(".probiotic").offset().top
      }else if(this.activeNav==5){
        _scrollbox =$(".profession").offset().top
      }
      $("html,body").animate({scrollTop:_scrollbox -48+ "px"}, 500);
    },
    // 屏幕滚动事件
    handleScroll(e){
        
        let top = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop
         if(top>this.height-48){
          this.boxShow = true
         }else{
          this.boxShow = false
         }
     
    },
  },
  mounted(){
    window.addEventListener('scroll', this.handleScroll) //添加监听浏览器滚动
    let _height = $(".productNav").offset().top
    this.height=_height
  },
}
</script>
<style>
#productPage{
  width: 100%;
  overflow: hidden;
}
.bannerBox{
  width: 100%;
  height:44vw;
  max-height:640px;
  background-repeat: no-repeat;
    background-size: auto 100%;
    background-position:center;
    -moz-background-size: 100% 100%;
}
.productNav{
  width: 100%;
  padding: 0 6.3vw;
  max-width: 1440px;
  margin:0 auto;
  height:62px;
  position: relative;
}
.productNavBox{
  width: 100%;
  height:62px;
  background:rgba(255,255,255,1);
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid rgba(203,190,178,0.2);
  z-index: 8;
}
.topNav{
  position: fixed;
  width: 100%;
  max-width: 1440px;
  top:48px;
  left: 50%;
  transform: translate(-50%,0);  
 /* margin-left: auto;
    margin-right: auto;*/
  z-index: 8;
  box-sizing: border-box;
}
.productNavLeft{
  height:62px;
  line-height: 62px;
  display: flex;
}
.productNavLeft div{
  font-size:16px;
  font-family:PingFangSC-Regular;
  font-weight:600;
  color:rgba(20,20,20,1);
  letter-spacing:1px;
  margin-right: 2vw;
  position: relative;
  cursor:pointer;
}
.navAc:after{
  height:3px;
  width: 100%;
  content: " ";
  background-color: rgba(194,94,77,1);
  position: absolute;
  bottom: 0;
  left: 0;
}
.productNavRight{
 height:62px;
  line-height: 62px;
  display: flex;
}
.productNavRight div{
  font-size:16px;
font-family:PingFangSC-Regular;
font-weight:400;
color:rgba(20,20,20,1);
margin-right: 13px;
}
.productNavRight img{
  width:28px;
  height:28px;
  display: block;
  margin-top: 18px;
}
.goods{
  width: 100%;
  margin: 0 auto;
  max-width: 1440px;
  overflow: hidden;
}
.goodsBox{
  padding:6vw;
  box-sizing: border-box;

}
.goodsTitle{
  margin:0 0.5vw;
  display: flex;
  height:45px;
  font-size:26px;
  font-family:PingFangSC-Semibold;
  font-weight:600;
  color:rgba(20,20,20,1);
  line-height:45px;
  letter-spacing:2px;
  border-bottom:1px solid rgba(203,190,178,0.31);
}
.goodsName{
  margin-right: 15px;
}
.goodsEn{
  height:45px;
  font-size:14px;
  font-family:OpenSans;
  color:rgba(120,120,120,1);
  line-height:62px;
}
.goodsSubject{
  display: flex;
  flex-wrap: wrap;

}
.goodsSubjectitme{
  /*margin-bottom:1vw;*/
  margin-right:1vw; 
  margin-left:0.2vw; 
  margin-top:3vw; 
}

.allNav{
  position: absolute;
  top:62px;
  
  left: 0;
  width: 100%;
  min-height:340px;
  /*background:rgba(255,255,255,1);*/
  padding: 6vw;
  padding-top:45px; 
  z-index: 100;
  box-sizing: border-box;

}
.allNavBox{
  box-shadow: 0 0 2vw 0.5vw rgba(0,0,0,0.18);
  border-radius: 10px;
  width: 100%;
  max-width: 820px;
  margin:0 auto;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  background:rgba(255,255,255,1);
  padding: 3vw 4vw 0;
}
.allNavItem{
  width: 90px;
  /*height:100px;*/
  margin-bottom: 3vw;
}
.allNavItem img{
  width: 40px;
  height:40px;
  display: block;
  margin:0 auto;
}
.allNavItem div{
  width: 90px;
  text-align:center;
  height:20px;
  font-size:14px;
  font-family:PingFangSC-Regular;
  font-weight:400;
  color:rgba(20,20,20,1);
  line-height:20px;
}
.colse{
  width:19px;
 height:19px;
 position: absolute;
 right: 2vw;
 top:2vw;
}
.itemtypeactive{
  background-color: rgba(224, 227, 222, 1);
}
</style>